import { action } from 'typesafe-actions';
import {
  DeleteDocumentPayload,
  DeleteDocumentResponse,
  DocActionTypes,
  SaveDocumentPayload,
  SaveDocumentResponse,
  SaveInternalDocumentPayload,
  SaveInternalDocumentResponse,
} from './types';
import { DocAccessType, IDocuments } from '../../../types';
import { uiTypes } from 'shared-components';

export function approveDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  docStatus?: string,
  docPrevStatus?: string,
) {
  return action(DocActionTypes.APPROVE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason: '',
    status: docStatus === 'APPROVED' && docPrevStatus ? docPrevStatus : 'APPROVED',
  });
}

export function acknowledgeDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  docStatus?: string,
  docPrevStatus?: string,
) {
  return action(DocActionTypes.ACKNOWLEDGE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason: '',
    status: docStatus === 'ACKNOWLEDGED' && docPrevStatus ? docPrevStatus : 'ACKNOWLEDGED',
  });
}

export function toggleDocStatusSuccess({
  docs,
  complete,
  required,
}: {
  docs: IDocuments;
  complete: number;
  required: number;
}) {
  return action(DocActionTypes.TOGGLE_DOC_SUCCESS, { docs, complete, required });
}

export function toggleDocStatusFailure(error: string) {
  return action(DocActionTypes.TOGGLE_DOC_FAILURE, {
    error,
  });
}

export function rejectDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  status: IDocuments['status'],
  reason?: string,
) {
  return action(DocActionTypes.REJECT_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason,
    status,
  });
}

export function rescindRejectDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  status: IDocuments['status'],
  reason?: string,
) {
  return action(DocActionTypes.RESCIND_REJECT_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason,
    status,
  });
}

export function deleteDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  reason?: string,
) {
  return action(DocActionTypes.DELETE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason,
    status: 'DELETED',
  });
}

export function requestCustomDoc(documentName: string, documentDescription: string, userAccess?: DocAccessType) {
  return action(DocActionTypes.CUSTOM_DOCUMENT_REQUEST, {
    documentName,
    documentDescription,
    userAccess,
  });
}

export const updateVisaRefusalMetaData = (
  sponsorType: string,
  sponsorKey: string,
  docType: string,
  docKey: string,
  metadata?: any,
) =>
  action(DocActionTypes.UPDATE_VISA_REFUSAL_META_DATA, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    metadata,
  });

export const updateVisaRefusalMetaDataSuccess = (docs: IDocuments) =>
  action(DocActionTypes.UPDATE_VISA_REFUSAL_META_DATA_SUCCESS, docs);

export const updateVisaRefusalMetaDataFailure = (error: string) =>
  action(DocActionTypes.UPDATE_VISA_REFUSAL_META_DATA_FAILURE, { error });

export const noBiometrics = (sponsorType: string, sponsorKey: string, docType: string, docKey: string) =>
  action(DocActionTypes.NO_BIOMETRICS, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
  });

export const updateTBTestMetaData = (sponsorType: string, docKey: string, metadata: uiTypes.ITBTestMetaData) =>
  action(DocActionTypes.UPDATE_TB_TEST_META, { sponsorType, docKey, metadata });

export const updateTBSuccess = (docs: IDocuments) => action(DocActionTypes.UPDATE_TB_SUCCESS, docs);

export const updateTBFailure = (error: string) => action(DocActionTypes.UPDATE_TB_FAILURE, { error });

export const saveDocument = (payload: SaveDocumentPayload) => action(DocActionTypes.SAVE_DOCUMENT, payload);

export const saveDocumentSuccess = (response: SaveDocumentResponse) =>
  action(DocActionTypes.SAVE_DOCUMENT_SUCCESS, response);

export const saveDocumentFailure = (error: string) => action(DocActionTypes.SAVE_DOCUMENT_FAILURE, { error });

export const saveInternalDocument = (payload: SaveInternalDocumentPayload) =>
  action(DocActionTypes.SAVE_INTERNAL_DOCUMENT, payload);

export const saveInternalDocumentSuccess = (response: SaveInternalDocumentResponse) =>
  action(DocActionTypes.SAVE_INTERNAL_DOCUMENT_SUCCESS, response);

export const saveInternalDocumentFailure = (error: string) =>
  action(DocActionTypes.SAVE_INTERNAL_DOCUMENT_FAILURE, { error });

export const deleteDocument = (payload: DeleteDocumentPayload) => action(DocActionTypes.DELETE_DOCUMENT, payload);

export const deleteDocumentSuccess = (response: DeleteDocumentResponse) =>
  action(DocActionTypes.DELETE_DOCUMENT_SUCCESS, response);

export const deleteDocumentFailure = (error: string) => action(DocActionTypes.DELETE_DOCUMENT_FAILURE, { error });
